import { useCallback, useContext, useState } from 'react';
import CustomTextArea from '../UI/CustomTextArea/CustomTextArea';
import CustomCheckbox from '../UI/CustomCheckbox/CustomCheckbox';
import styled from 'styled-components';
import CustomButton from '../UI/CustomButton/CustomButton';
import { PageContext } from '../../context/context';
import { AlertKeys } from '../UI/Alert/Alert.types';
import { PageKeys } from '../../App.types';
import { fetchPost } from '../../services/fetchFunc';
import { useMutation } from '@tanstack/react-query';

export function Transfer() {
    const {
        setAlert,
        setPage,
        setData,
        setSuccessMessage,
        setErrorMessage,
        data: appointmentData,
    } = useContext(PageContext);
    const [comment, setComment] = useState<string>('');
    const [isCallMeBack, setIsCallMeBack] = useState<boolean>(false);
    // const cancelAppointmentSession = window.sessionStorage.getItem(
    //     'cancelAppointmentSession',
    // );
    const id = new URLSearchParams(window.location.search).get('id');

    const { mutate, isPending } = useMutation({
        mutationFn: () =>
            fetchPost({
                // session: cancelAppointmentSession,
                id,
                comment,
                callback: isCallMeBack,
                action: 'move-appointment',
            }),
        onSuccess: (data) => {
            if (data?.error) {
                if (data?.error?.code == 401) {
                    setErrorMessage(data.error.message);
                    setPage(PageKeys.error);
                    setAlert(AlertKeys.none);
                } else {
                    setErrorMessage(data.error.message);
                    setPage(PageKeys.error);
                    setAlert(AlertKeys.none);
                }
            }
            if (data?.moved) {
                setData({ ...appointmentData, status: 'moving' });
                setSuccessMessage('Ваша запись перенесена');
                setAlert(AlertKeys.success);
                console.log(appointmentData);
            }
        },
        onError: (err) => {
            if (err instanceof Error) {
                setErrorMessage(err.message);
                setPage(PageKeys.error);
                setAlert(AlertKeys.none);
                console.log(err.message);
            }
        },
    });

    const handleClickConfirm = useCallback(() => {
        mutate();
        console.log('handleClickBack');
    }, [mutate]);

    const handleClickBack = useCallback(() => {
        setAlert(AlertKeys.none);
        console.log('handleClickBack');
    }, [setAlert]);
    return (
        <StyledTransfer>
            <StyledTransferContent>
                <h3>Перенос записи</h3>
                <p>
                    Пожалуйста, укажите свои пожелания по переносу записи в
                    свободной форме. В случае успешного переноса мы пришлем
                    СМС-уведомление с информацией о новой записи, либо свяжемся
                    с Вами для согласования возможных вариантов.
                </p>

                <CustomTextArea
                    placeholder="Комментарий"
                    value={comment}
                    setValue={setComment}
                />

                <CustomCheckbox
                    checked={isCallMeBack}
                    setChecked={setIsCallMeBack}
                >
                    Перезвоните мне
                </CustomCheckbox>
                <StyledTransferButtons>
                    <CustomButton
                        disabled={isPending}
                        onClick={handleClickConfirm}
                        type={'third'}
                    >
                        Перенести
                    </CustomButton>
                    <CustomButton
                        disabled={isPending}
                        onClick={handleClickBack}
                        type={'primary'}
                    >
                        Нет
                    </CustomButton>
                </StyledTransferButtons>
            </StyledTransferContent>
        </StyledTransfer>
    );
}

const StyledTransfer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    background: #fff;
    padding-top: 40px;
    padding-bottom: 40px;
    padding-right: 24px;
    padding-left: 24px;
`;
const StyledTransferContent = styled.div`
    max-width: 598px;
    width: 100%;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    gap: 16px;
    && p {
        font-weight: 600;
        font-size: 16px;
        line-height: 140%;
        padding: 0 !important;
        margin: 0 !important;
        text-align: left;
        @media (max-width: 768px) {
            font-size: 14px;
        }
    }
    && h3 {
        font-weight: 700;
        font-size: 20px;
        line-height: 120%;
        text-align: center;
        margin-bottom: 16px !important;
        text-align: left;
        padding: 0 !important;
    }
`;

const StyledTransferButtons = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding-top: 16px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
    }
`;
